import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppModule } from '../app.module';
import { SEOService } from './pages/shared/seoService';
import { AuthService } from './pages/shared/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  private seoService = inject(SEOService);
  private authService = inject(AuthService);

  showEmailSubscription = false;
  userIsAgent = false;
  private unsubscribe$ = new Subject();

  constructor() {
    this.seoService.updatePageMetaData();
  }

  ngOnInit() {
    this.authService.ndvUser$.pipe(takeUntil(this.unsubscribe$)).subscribe((user) => {
      if (user?.status === 'agent_active' || user?.status === 'agent_confirmation') {
        this.userIsAgent = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
